import { jsx as w } from "react/jsx-runtime";
import { c as Y } from "react/compiler-runtime";
import { Box as I } from "@mui/material";
import { DayPicker as N } from "react-day-picker";
import "react-day-picker/style.css";
import { styles as S } from "./DateTimeSelect.style.js";
import m from "moment-timezone";
const O = (C) => {
  const e = Y(26), {
    selectedDate: g,
    onDateChange: h,
    month: M,
    year: T,
    minTime: f,
    maxTime: c,
    startDate: d,
    endDate: D,
    dateType: _
  } = C, k = parseInt(T), x = parseInt(M);
  let i;
  e[0] !== k || e[1] !== x ? (i = new Date(k, x), e[0] = k, e[1] = x, e[2] = i) : i = e[2];
  let p;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = {
    width: "100%"
  }, e[3] = p) : p = e[3];
  const u = g * 1e3;
  let a;
  e[4] !== u ? (a = new Date(u), e[4] = u, e[5] = a) : a = e[5];
  let l;
  e[6] !== h ? (l = (t) => {
    h(m(t, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ").unix());
  }, e[6] = h, e[7] = l) : l = e[7];
  let n;
  e: {
    if (_ === "end" && d) {
      let t;
      e[8] !== d ? (t = m.unix(d).toDate(), e[8] = d, e[9] = t) : t = e[9], n = t;
      break e;
    }
    if (f && f > 0) {
      let t;
      e[10] !== f ? (t = m.unix(f).toDate(), e[10] = f, e[11] = t) : t = e[11], n = t;
      break e;
    }
    n = void 0;
  }
  let r;
  e: {
    if (_ === "start" && D) {
      let o;
      e[12] !== D ? (o = m.unix(D).toDate(), e[12] = D, e[13] = o) : o = e[13], r = o;
      break e;
    }
    if (c && c !== 1 / 0) {
      let o;
      e[14] !== c ? (o = m.unix(c).toDate(), e[14] = c, e[15] = o) : o = e[15], r = o;
      break e;
    }
    let t;
    e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (t = m().endOf("day").toDate(), e[16] = t) : t = e[16], r = t;
  }
  let s;
  e[17] !== n || e[18] !== r ? (s = {
    before: n,
    after: r
  }, e[17] = n, e[18] = r, e[19] = s) : s = e[19];
  let y;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = {
    week: {
      backgroundColor: "transparent"
    }
  }, e[20] = y) : y = e[20];
  let b;
  return e[21] !== s || e[22] !== i || e[23] !== a || e[24] !== l ? (b = /* @__PURE__ */ w(I, { sx: S.calenderContainer, children: /* @__PURE__ */ w(N, { mode: "single", month: i, style: p, showWeekNumber: !1, hideNavigation: !0, className: "date-time-selector-calender", selected: a, onDayClick: l, disabled: s, styles: y }) }), e[21] = s, e[22] = i, e[23] = a, e[24] = l, e[25] = b) : b = e[25], b;
};
export {
  O as DatePickerComponent
};
